//This is a list of slugs which need an AJM CTA. We will remove this once we get the graphQL working.
export const AJMArticleSlugs = ["debt-collection-lawsuit-new-york"];
